import { createTheme } from "@mui/material"
import { theme as customTheme } from "./theme"

declare module "@mui/material/styles" {
  interface TypographyVariants {
    note: React.CSSProperties
    tableHeader: React.CSSProperties
    redTableHeader: React.CSSProperties
    tableHeaderMaintenance: React.CSSProperties
    statusText: React.CSSProperties
    redLabel: React.CSSProperties
    dayLabel: React.CSSProperties
    viewConfigText: React.CSSProperties
    label: React.CSSProperties
    value: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    note?: React.CSSProperties
    tableHeader?: React.CSSProperties
    redTableHeader: React.CSSProperties
    tableHeaderMaintenance: React.CSSProperties
    statusText: React.CSSProperties
    redLabel: React.CSSProperties
    dayLabel: React.CSSProperties
    viewConfigText: React.CSSProperties
    label: React.CSSProperties
    value: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    note: true
    tableHeader: true
    redTableHeader: true
    tableHeaderMaintenance: true
    statusText: true
    redLabel: true
    dayLabel: true
    viewConfigText: true
    label: true
    value: true
  }
}

declare module "@mui/material/styles" {
  interface Palette {
    customColors: {
      positive: string
      textGreen: string
      textGrey1: string
      hoverPrimary: string
      buttonBackgroundGrey: string
    }
    tableColors: {
      header: string
      body: string
      borderGreen: string
    }
    borderColors: {
      50: string
    }
    textColors: {
      grey1: string
      grey2: string
      grey3: string
      grey4: string
      themeWhite: string
    }
    backgrounds: {
      50: string
    }
    status: {
      green: string
      yellow: string
      neutral: string
      red: string
    }
  }
}

declare module "@mui/material/styles" {
  interface PaletteOptions {
    customColors: {
      positive: string
      textGreen: string
      textGrey1: string
      hoverPrimary: string
      buttonBackgroundGrey: string
    }
    tableColors: {
      header: string
      body: string
      borderGreen: string
    }
    borderColors: {
      50: string
    }
    textColors: {
      grey1: string
      grey2: string
      grey3: string
      grey4: string
      themeWhite: string
    }
    backgrounds: {
      50: string
    }
    status: {
      green: string
      yellow: string
      neutral: string
      red: string
    }
  }
}

export const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Montserrat",
    },
    note: {
      fontStyle: "italic",
      fontSize: 11,
      fontWeight: 400,
      letterSpacing: "0em",
      color: "#333333",
    },
    tableHeader: {
      fontWeight: 600,
    },
    redTableHeader: {
      // color: "#CA0E19",
      color: "#2FD4CF",
      fontWeight: 700,
      fontSize: 16,
    },
    tableHeaderMaintenance: {
      fontWeight: 600,
      fontSize: 16,
      color: "#7D7D7D",
    },
    statusText: {
      color: "#7D7D7D",
      fontSize: 12,
      fontWeight: 400,
    },
    viewConfigText: {
      color: "#7D7D7D",
      fontSize: 11,
      fontWeight: 600,
    },
    redLabel: {
      // color: customTheme.redLabelColor,
      color: "#000000",
      fontWeight: 500,
      fontSize: 14.57,
    },
    dayLabel: {
      color: customTheme.dayLabelColor,
      fontWeight: 500,
      fontSize: 14.57,
    },
    label: {
      fontWeight: 500,
      fontSize: 14,
      color: customTheme.blackColorLabel,
    },
    value: {
      fontWeight: 700,
      fontSize: 14,
    },
  },
  palette: {
    primary: {
      main: customTheme.primary,
    },
    // secondary: {
    //   main: customTheme.secondaryColor,
    // },
    customColors: {
      positive: "#D0FAE5",
      textGreen: "#305236",
      textGrey1: "#565759",
      hoverPrimary: "#2bc4c0",
      buttonBackgroundGrey: "#EAEBED",
    },
    tableColors: {
      header: "#F8F9FB",
      body: "#EDEDED",
      borderGreen: "#27AF8D",
    },
    borderColors: {
      50: "#E3E6EB",
    },
    textColors: {
      grey1: "#737B87",
      grey2: "#636363",
      grey3: "#F4F4F4",
      grey4: "#D5D5D5",
      themeWhite: "#FFFFFF",
    },
    backgrounds: {
      50: "#73737326",
    },
    status: {
      green: "#30D468",
      yellow: "#F6BB42",
      neutral: "#73737326",
      red: "#ff0f0f",
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#F8BEBE", // Change this to your desired color
        },
      },
    },
    MuiTableCell: {
      defaultProps: {
        align: "center",
      },
      styleOverrides: {
        body: {
          // fontWeight:'bold'
          fontSize: 14,
          fontWeight: 500,
          lineHeight: "17.07px",
          letterSpacing: "0.4375px",
          color: "#000000",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "white",
          color: "rgba(0, 0, 0, 0.87)",
          border: "1px solid black",
          // boxShadow: theme.shadows[1],
          fontSize: 11,
          fontFamily: "Montserrat",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 14,
        },
      },
    },
  },
})
